import { Page } from '@/core/architecture'

import { FavoriteMembersSelectTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * FavoriteMembersSelect Page
 * Implemented as a practical sample.
 */
export const FavoriteMembersSelect: Page = () => {
  const { state, actions } = useViewModel()

  return <FavoriteMembersSelectTemplate state={state} {...actions} />
}
